"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StickyMenu = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.StickyMenu = styled_components_1.default.div `
  flex-shrink: 0;
  position: relative;
`;
//# sourceMappingURL=sticky-menu.js.map